import ProfessionalMailingAdrTile from './ProfessionalMailingAdrTile';

export default ProfessionalMailingAdrTile;
